<template>
  <div id="footer">
    <div class="px1200">
      <div class="bottom1"> <img src="https://www.gsmtjyzx.com/bootstrap/img/GH.png" style="width:13px" alt=""> 甘公网安备 62010202001483号 版权所有 陇ICP备20000113号</div>
      <div class="bottom2">Copyright@2020 GCTC · GanSu Coal Trading Center.All Rights Reserved</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
#footer {
  width: 100%;
  height: 80px;
  background: #ececec;
  padding: 21px 0;
  text-align: center;
  .bottom1{
      margin-bottom: 7px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DataFooter.vue